import { Directive, AfterViewInit, ViewContainerRef, TemplateRef, Input } from '@angular/core';

@Directive({
  selector: '[off-visible]',
})
export class VisibleDirective implements AfterViewInit {

  @Input() once: boolean = false
  constructor(private vcRef: ViewContainerRef, private tplRef: TemplateRef<any>) {
  }

  seen = false
  count = 0

  ngAfterViewInit() {
    const observedElement = this.vcRef.element.nativeElement.parentElement

    const observer = new IntersectionObserver(([entry]) => {
 
      console.log(this.count)
      this.renderContents(entry.isIntersecting)
      this.count += 1
      this.seen = true
    })
    observer.observe(observedElement)
  }

  renderContents(isIntersecting: boolean) {

    this.vcRef.clear()
    if (isIntersecting) {
      this.vcRef.createEmbeddedView(this.tplRef)
    }
  }
}
